import gql from 'graphql-tag';
export const StatFeatureOrgInquiries = gql `
    fragment StatFeatureOrgInquiries on OrgInquiriesFeatureSettingsFlags {
        isEnabled
        canOptIn
    }
`;
